<template>
    <div class="box autho-manage">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <div style="display: flex;align-items: center">
                <span class="el-icon-back" style="font-size: 30px;margin-right: 15px;cursor:pointer" @click="handleBack"></span>
                <el-breadcrumb-item>设备应用授权</el-breadcrumb-item>
            </div>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <h1 style="text-align: left;color: #666">当前设备：{{deviceName}}</h1>
        <el-form :inline="true" class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="" prop="SearchKey">
                <el-input placeholder="请输入关键词" v-model="model.SearchKey" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
                <el-button type="primary" icon="el-icon-document-copy" @click="handleClone">克隆应用</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%" @selection-change="selectChange" highlight-current-row :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="AppID" label="ID" sortable width="80">
            </el-table-column>
            <el-table-column prop="AppShowName" label="应用显示名称" sortable width="150">
            </el-table-column>
            <el-table-column prop="RightGroup" label="权限组" sortable width="150">
            </el-table-column>
            <el-table-column prop="Icon" label="应用图标" sortable width="150">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="width:60px;height:auto;margin-right:8px" :src="scope.row.Icon" :preview-src-list="scope.row.Icon | filterLogo">
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="Name" label="应用分类" sortable width="150">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.Name" placeholder="请选择" @change="(val)=>{handleChange(val,scope.row.OID)}">
                        <el-option v-for="item in options" :key="item.OID" :label="item.CategoryName" :value="item.OID">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="IconColor" label="图标颜色" sortable width="150">
            </el-table-column>
            <el-table-column prop="IconShadow" label="图标阴影颜色" sortable width="150">
            </el-table-column>
            <el-table-column prop="AppType" label="应用类型" sortable width="120">
            </el-table-column>
            <el-table-column prop="AppState" label="应用授权类型" sortable width="150">
            </el-table-column>
            <el-table-column prop="AppDueTime" label="应用到期时间" sortable width="150">
            </el-table-column>
            <el-table-column prop="AppVersion" label="应用版本" sortable width="120">
            </el-table-column>
            <el-table-column prop="Url" label="应用跳转路径" sortable width="150">
            </el-table-column>
            <el-table-column prop="Sort" label="应用排序" sortable width="150">
                <template slot-scope="scope">
                    <input type="text" v-model="scope.row.Sort" style="width:50px"  @change="handleSortChange(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="IsShow" label="是否显示" sortable width="150">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.IsShow" disabled=""></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="IsDefault" label="是否为屏保应用" sortable width="150">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.IsDefault" disabled=""></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    <el-button size="mini" type="warning" @click="handleInitAppDataTable(scope.row)" v-if="scope.row.InitDataKey">初始化应用表</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination background @current-change="handleCurrentChange" :current-page="model.Page" layout="total,prev, pager, next, jumper" :total="listCount" :page-size="model.Rows">
            </el-pagination>
        </el-row>
        <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd" :deviceOID="this.model.OID" :deviceType="deviceType"></add>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData" :deviceOID="this.model.OID"></edit>
        <clone v-if="isShowClone" :dialogFormVisible="isShowClone" @closeCloneDialog="handleCloseClone" :companyName="companyName" :CompanyID="CompanyID" :deviceType="deviceType" :DeviceID="id" :deviceName="deviceName" :deviceOID="this.model.OID"></clone>
    </div>
</template>

<script>
    import { GetDeviceAppList, DeleteDeviceApp, InitAppDataTable, GetDACategorylist, UpdateDeviceApp } from '../../../api/device'
    import { UpdateDeviceAppCategory } from '../../../api/appType'
    import add from './add'
    import edit from './edit'
    import clone from './clone'
    export default {
        components: {
            add,
            edit,
            clone
        },
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                isShowClone: false,
                listCount: null,
                dataList: [],
                editData: [],
                model: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                    OID: null
                },
                updataModel: {
                    OID: Number,
                    CategoryID: Number,

                },
                options: [],

            }
        },
        props: {
            id: {
                required: true,
            },
            deviceName: {
                required: true,
            },
            CompanyID: {
                required: true,
            },
            deviceType: {
                required: true
            },
            companyName: {
                required: true
            },
            CompanyCode: {
                required: true
            },
            DeviceCode: {
                required: true
            }
            // deviceId: {
            //     required: true
            // }
        },
        watch: {
            'model.SearchKey': {
                handler(newVal, oldVal) {
                    if (newVal === '') {
                        this.model.SearchKey = '';
                        this.GetDeviceAppList();
                    }
                }
            }
        },
        filters: {
            filterLogo(Icon) {
                if (Icon) {
                    return Icon.split()
                }
            },
        },
        mounted() {
            this.model.OID = this.id;
            // this.updataModel.OID = Number(this.deviceId);
            console.log(this.CompanyID)
            this.GetDACategorylist();
        },
        methods: {
            GetDACategorylist() {
                GetDACategorylist({ Page: 1, Rows: 10, CompanyCode: this.CompanyCode, DeviceCode: this.DeviceCode }).then(data => {
                    if (!data.iserror) {
                        console.log(data.data.List)
                        this.options = data.data.List;
                        console.log('this.options')
                        console.log(this.options)
                        this.$nextTick(() => {
                            this.GetDeviceAppList();
                        })
                    }
                })
            },
            GetDeviceAppList() {
                GetDeviceAppList(this.model).then(data => {
                    if (!data.iserror) {
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.model.Page = val;
                this.GetDeviceAppList();
            },
            selectChange(val) {
                this.selectdata = val
            },
            handleSearch() {
                if (this.model.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.model.Page = 1;
                this.GetDeviceAppList();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleCloseAdd() {
                this.isShowAdd = false;
                this.GetDeviceAppList();
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetDeviceAppList();
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认要删除该应用吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteDeviceApp(id);
                })
            },
            DeleteDeviceApp(id) {
                DeleteDeviceApp({ OID: id }).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetDeviceAppList();
                    }
                })
            },
            handleBack() {
                this.$emit('showDevice')
            },
            handleInitAppDataTable(row) {
                let InitDataKey = row.InitDataKey;
                let DeviceID = this.model.OID;
                this.$confirm('该操作会生成新的数据库表结构，请谨慎操作！！！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    InitAppDataTable({ InitDataKey: InitDataKey, DeviceID: DeviceID }).then(data => {
                        if (!data.error) {
                            this.$message({
                                message: '初始化成功',
                                type: 'success'
                            });
                        }
                    })
                })
            },
            handleClone() {
                this.isShowClone = true;
            },
            handleCloseClone() {
                this.isShowClone = false;
                this.GetDeviceAppList();
            },
            handleChange(val, id) {
                console.log(val)
                this.updataModel.CategoryID = Number(val);
                this.updataModel.OID = Number(id)
                console.log(id)
                this.UpdateDeviceAppCategory();
            },
            //修改设备应用授权分类
            UpdateDeviceAppCategory() {
                console.log(this.updataModel)
                UpdateDeviceAppCategory({ CategoryID: this.updataModel.CategoryID, OID: this.updataModel.OID }).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '应用分类修改成功',
                            type: 'success'
                        });
                    }
                })
            },
            //更改排序
            handleSortChange(row) {
                console.log(88)
                console.log(row)
                this.UpdateDeviceApp(row)
            },
            //编辑排序
            UpdateDeviceApp(row) {
                UpdateDeviceApp(row).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '更新成功',
                            type: 'success'
                        });
                        this.GetDeviceAppList()
                    }
                })
            },
        }
    }
</script>

<style>
    .box.autho-manage .el-table th,
    .box.autho-manage .el-table tr {
        background-color: #ecf5ff;
    }
</style>